export default {
  IS_MOCK_API: true,
  SERVICE_API_URL: process.env.REACT_APP_SERVICE_API_URL || "http://mafzmac.local:5020/dev",
}
